// 저장된 내러티브 HTML을 그리기 직전에 손보는 곳.
//
// 편집 화면에서는 tiptap(TableView)이 표마다 <div class="tableWrapper">를 씌워 주지만,
// editor.getHTML()이 내놓는 저장본에는 그 래퍼가 없다. 래퍼가 없으면 본문 폭보다 넓은
// 표가 갈 곳이 없어 상자 밖으로 — 셀 안 표라면 셀 밖으로 — 그냥 흘러넘쳐 뒤 내용 위에
// 겹쳐 그려진다. 그래서 뷰어(SiteNarrativeViewer, NarrativeView, NarrativeDiff,
// SiteConsentGate)는 그릴 때 같은 래퍼를 되돌려 주고, 스크롤 규칙은 에디터와 함께 쓰는
// narrativeContentStyles의 .tableWrapper가 맡는다.

export const TABLE_WRAPPER_CLASS = "tableWrapper";

/**
 * 표마다 가로 스크롤 래퍼를 씌운 HTML을 돌려준다. 표가 없으면 원본 그대로다.
 *
 * 중첩된 표도 각자 자기 래퍼를 갖는다(바깥 표부터 감싸도 안쪽 표는 문서에 그대로
 * 남아 있어 이어서 감쌀 수 있다). 이미 래퍼 안에 있는 표는 건너뛴다.
 */
export function withTableWrappers(html) {
  if (!html || typeof html !== "string" || !html.includes("<table")) return html;
  if (typeof DOMParser === "undefined") return html;

  const doc = new DOMParser().parseFromString(html, "text/html");

  doc.body.querySelectorAll("table").forEach((table) => {
    const parent = table.parentElement;
    if (parent && parent.classList.contains(TABLE_WRAPPER_CLASS)) return;

    const wrapper = doc.createElement("div");
    wrapper.className = TABLE_WRAPPER_CLASS;
    table.replaceWith(wrapper);
    wrapper.appendChild(table);
  });

  return doc.body.innerHTML;
}
